import styled from "styled-components";

import { Spaces } from "../../../../../core/styles/theme/spaces";

export const CompactRowsStyle = styled.div`
    .ant-table-tbody > tr > td {
        padding: ${Spaces.SmallPadding} ${Spaces.Padding};
    }

    .aevi-input {
        height: 28px;
    }
`;
